type RootState = {
  general?: {
    usersFeaturedData?: any[];
  };
  register?: {
    usersBySkill?: any[];
    itemCount?: number;
    page?: number;
    allCountryUsers?: number;
    validatedExplore?: { true: number; false: number };
    validatedApplied?: { true: number; false: number };
    typesExplore?: { person: number; company: number; workers: number; total: number };
    skillsList?: any[];
  };
  profile?: {
    usersInJurisdiction?: any[];
  };
};

export const selectFeaturedUsers = (state: RootState) =>
  state.general?.usersFeaturedData ?? [];

export const selectSkillsList = (state: RootState) => state.register?.skillsList ?? [];

export const selectJurisdictions = (state: RootState) =>
  state.profile?.usersInJurisdiction ?? [];

export const selectFilteredUsers = (state: RootState) =>
  state.register?.usersBySkill ?? [];

export const selectFilteredMeta = (() => {
  let lastItemCount = 0;
  let lastPage = 1;
  let lastAllCountryUsers: number | undefined;
  let lastValidatedExploreKey = "";
  let lastValidatedAppliedKey = "";
  let lastTypesExploreKey = "";
  let lastResult = {
    itemCount: 0,
    page: 1,
    allCountryUsers: undefined as number | undefined,
    validatedExplore: undefined as { true: number; false: number } | undefined,
    validatedApplied: undefined as { true: number; false: number } | undefined,
    typesExplore: undefined as { person: number; company: number; workers: number; total: number } | undefined,
  };

  return (state: RootState) => {
    const registerState: any = state.register ?? {};
    const itemCount = registerState?.itemCount ?? 0;
    const page = registerState?.page ?? 1;
    const allCountryUsers =
      typeof registerState?.allCountryUsers === "number" ? registerState.allCountryUsers : undefined;
    const validatedExplore =
      registerState?.validatedExplore && typeof registerState.validatedExplore === "object"
        ? registerState.validatedExplore
        : undefined;
    const validatedApplied =
      registerState?.validatedApplied && typeof registerState.validatedApplied === "object"
        ? registerState.validatedApplied
        : undefined;
    const typesExplore =
      registerState?.typesExplore && typeof registerState.typesExplore === "object"
        ? registerState.typesExplore
        : undefined;
    const validatedExploreKey = validatedExplore ? `${validatedExplore.true}|${validatedExplore.false}` : "";
    const validatedAppliedKey = validatedApplied ? `${validatedApplied.true}|${validatedApplied.false}` : "";
    const typesExploreKey = typesExplore
      ? `${typesExplore.person}|${typesExplore.company}|${typesExplore.workers}|${typesExplore.total}`
      : "";

    if (
      itemCount !== lastItemCount ||
      page !== lastPage ||
      allCountryUsers !== lastAllCountryUsers ||
      validatedExploreKey !== lastValidatedExploreKey ||
      validatedAppliedKey !== lastValidatedAppliedKey ||
      typesExploreKey !== lastTypesExploreKey
    ) {
      lastItemCount = itemCount;
      lastPage = page;
      lastAllCountryUsers = allCountryUsers;
      lastValidatedExploreKey = validatedExploreKey;
      lastValidatedAppliedKey = validatedAppliedKey;
      lastTypesExploreKey = typesExploreKey;
      lastResult = { itemCount, page, allCountryUsers, validatedExplore, validatedApplied, typesExplore };
    }

    return lastResult;
  };
})();
